import"react";function r(){for(var r=arguments.length,n=Array(r),t=0;t<r;t++)n[t]=arguments[t];return function(r){n.forEach(function(n){"function"==typeof n?n(r):null!=n&&(n.current=r)})}}export{r as mergeRefs};
//# sourceMappingURL=react.js.map
